export const movieInfo = [
    {
        belongs_to_collection: {
            id: 131292,
            name: "Iron Man Collection",
            poster_path: "/fbeJ7f0aD4A112Bc1tnpzyn82xO.jpg",
            backdrop_path: "/rI8zOWkRQJdlAyQ6WJOSlYK6JxZ.jpg"
        },
        _id: "654e43c8384f910ce5614b9d",
        adult: false,
        backdrop_path: "/aFTYFqrWp4RS46Twm87l5e0ItYb.jpg",
        genres : [
            {
                id: 28,
                name: "Action",
                _id: "654e43c8384f910ce5614b9e"
            },
            {
                id: 12,
                name: "Adventure",
                _id: "654e43c8384f910ce5614b9f"
            },
            {
                id: 878,
                name: "Science Fiction",
                _id: "654e43c8384f910ce5614ba0"
            }
        ], 
        homepage: "https://www.marvel.com/movies/iron-man-3",
        id: 68721,
        imdb_id: "tt1300854",
        original_language: "en",
        original_title: "Iron Man 3",
        overview: "When Tony Stark's world is torn apart by a formidable terrorist called the Mandarin, he starts an odyssey of rebuilding and retribution.",
        popularity: 66.955,
        poster_path: "/qhPtAc1TKbMPqNvcdXSOn9Bn7hZ.jpg",
        production_companies: [
            {
                id: 420,
                logo_path: "/hUzeosd33nzE5MCNsZxCGEKTXaQ.png",
                name: "Marvel Studios",
                origin_country: "US",
                _id: "654e43c8384f910ce5614ba1"
            }
        ],
        release_date: "2013-04-18",
        runtime: 130,
        spoken_languages: [
            {
                english_name: "English",
                iso_639_1: "en",
                name: "English",
                _id: "654e43c8384f910ce5614ba2"
            }
        ],
        status: "Released",
        tagline: "Unleash the power behind the armor.",
        title: "Iron Man 3",
        video: false,
        vote_average: 6.927,
        vote_count: 21135,
        __v: 0
    }
]